import * as React from 'react'
import styled from 'styled-components'
import { ThemeName } from '../../../lib/constants'
import CustomLink from '../../CustomLink'

export const Logo = styled.div`
  align-items: center;
  display: flex;
  height: 2rem;
  margin-bottom: 0.5rem;
`

export const LogoImage = styled.img`
  display: block;
  max-height: 2rem;
  max-width: 4rem;
  object-fit: cover;
`

export const Wrapper = styled(CustomLink)`
  background-color: ${({ theme }) => theme.colors.white[3]};
  border-radius: 0.5rem;
  border: 0;
  color: ${({ theme }) => theme.colors.black[1]};
  display: block;
  padding: 1rem;
  text-decoration: none;
  transition: background 0.125s ease-in-out, box-shadow 0.125s ease-in-out;

  &:hover {
    background-color: var(--c-theme-7);
    box-shadow: 0 0.5rem 2rem var(--c-theme-7);
  }
`

export const Label = styled.div`
  color: var(--c-theme-2);
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 1.1;
  margin-bottom: 0.3rem;
`

export const Text = styled.div`
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.1;
`

export interface CustomerStoryCardProps {
  logo: string
  children: string
  theme?: ThemeName
  alt: string
  [key: string]: any
}

export const CustomerStoryCard = ({ children, logo, theme, alt, ...rest }: CustomerStoryCardProps) => {
  return (
    <Wrapper className={theme} {...rest}>
      <Logo>
        <LogoImage src={logo} alt={alt} />
      </Logo>
      <Label>Customer story</Label>
      <Text>{children}</Text>
    </Wrapper>
  )
}
